// const HOST = 'http://tryon.xiaojingxiuxiu.com/api';
// const HOST = 'http://tryon.me/api';
// const HOST = 'http://127.0.0.1:8080';
// const HOST = 'http://facecloud.me';
const HOST = 'https://facecloud.panxsoft.com';


// export const USER_RESULT = `${ HOST }/tryon2d/userimg`;

export const FRAME_RESULT = `${ HOST }/open/api/tryon2d/frameimg`;
export const TEMPLE_RESULT = `${ HOST }/tryon2d/templeimg`;

// export const FRAME_RESULT = `${ HOST }/web/v1/face/frame`;

// export const TEMPLE_RESULT = `${ HOST }/web/v1/face/temple`;

// export const UUID_TO_ASSET = `${ HOST }/open-try-on/sdk/v1/glass-2d-asset`;

// export const UUID_TO_ASSET = '/api/open-try-on/sdk/v1/glass-2d-asset';
export const UUID_TO_ASSET = `${ HOST }/web/v1/face/glass-2d-asset`;
export const USER_RESULT = `${ HOST }/open/api/tryon2d/userimg`;
